import { 
        createBrowserRouter, 
        Route, 
        createRoutesFromElements,
        RouterProvider
      } from "react-router-dom"
      
  
//pages
import Home from "./pages/Home"
import About from "./pages/About"
import Bios from "./pages/Bios"
import Resources from "./pages/Resources"
import Highlight from "./pages/Highlight"
import Community from "./pages/Community"

//elements
import Team from "./elements/team/Team"
import Footer from "./elements/footer/Footer"
//layouts
import RootLayout from "./layouts/RootLayout"


const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<RootLayout />}>
      <Route index element={<Home />} />
      <Route path="about" element={<About />} />
      <Route path="team" element={<Team/>}/>
      <Route path="bios" element={<Bios/>}/>
      <Route path="resources" element={<Resources/>}/>
      <Route path="highlight" element={<Highlight/>}/>
      <Route path="community" element={<Community />} />
      <Route path="footer" element={<Footer />} />
    </Route>
  ))




function App() {
  return (  
    <RouterProvider router={router} />  
  );
}

export default App;
